import React from 'react';

type Props = { tone: 'info' | 'warn'; title: string; children: React.ReactNode };

// The page has two kinds of notes: info (Code tab works, the hook won't trap
// you) and warn (what failure looks like, connectors don't work).
const Callout: React.FC<Props> = ({ tone, title, children }) => (
  <div
    className={`flex gap-2.5 rounded-lg px-3.5 py-3 text-sm text-gray-700 ${
      tone === 'warn' ? 'border border-amber-200 bg-amber-50' : 'bg-blue-50'
    }`}
  >
    <span
      className={`mt-0.5 grid h-[18px] w-[18px] flex-none place-items-center rounded-full text-[11px] font-bold text-white ${
        tone === 'warn' ? 'bg-amber-600' : 'bg-blue-600'
      }`}
    >
      {tone === 'warn' ? '!' : 'i'}
    </span>
    <div className="min-w-0">
      <div className="mb-0.5 font-semibold text-gray-900">{title}</div>
      <div>{children}</div>
    </div>
  </div>
);

export default Callout;
